import React, { useState, useEffect, useContext } from 'react'; 
import './AboutCompany.css'; 
import { Container, Row, Col } from 'react-bootstrap';

import { LandingContext } from '../Profile/LandingContext';
import DefaultData from '../../CompanyData/DefaultData';

const coreValues = [
    { 
        name: 'Open Mindedness', 
        icon: 'ri-chat-smile-2-line',
        text: 'We are open in our dealings and foster a climate of trust and support. We listen actively, communicate openly, and appreciate feedback.'
    },
    { 
        name: 'Freedom through Responsibility', 
        icon: 'ri-shield-user-line',
        text: 'We provide our people with accountability, responsibility, and the resources they need to reach their full potential.'
    },
    { 
        name: 'Enterprising Spirit', 
        icon: 'ri-rocket-2-line',
        text: 'We encourage an innovative and resourceful mindset to constantly improve and adapt in the travel industry.'
    },
];

// Data from the "Why Choose Us" PDF slides
const whyChooseUsPoints = [
    { title: 'Global Inventory', icon: 'ri-global-line', text: 'Directly connected to leading hotel chains and 130+ airlines, offering a global database with the best contracted rates.' },
    { title: 'Expert Team', icon: 'ri-team-fill', text: 'Our highly trained, enthusiastic staff have a wealth of specialized knowledge and first-hand experience in all aspects of the travel industry.' },
    { title: 'Advanced Technology', icon: 'ri-cpu-line', text: 'Backed up with the latest technology, including advanced filters and smart integration, to ensure everything runs smoothly.' },
    { title: 'Value for Money', icon: 'ri-money-dollar-circle-line', text: 'We always offer our agents the best possible value, deals, and promotions with a standard of service that is second to none.' },
];

// Data for Accreditations from the PDF
const accreditations = [
    { name: 'IATA', fullName: 'International Air Transport Association', logo: '/assets/images/iata.png' },
    { name: 'MATTA', fullName: 'Malaysian Association of Tour & Travel Agents', logo: '/assets/images/matta.png' },
    { name: 'PATA', fullName: 'Pacific Asia Travel Association', logo: '/assets/images/pata.png' },
    { name: 'IAGTO', fullName: 'International Association Of Golf Tour Operators', logo: '/assets/images/iagto.png' },
];
 

const AboutCompany = () => {
   const landingData = useContext(LandingContext);
    const pageStyles = {
        '--theme-primary-color': landingData?.themeColor1 || DefaultData?.THEMECOLOR1,
        '--theme-secondary-color': landingData?.themeColor2 || DefaultData?.THEMECOLOR2
    };
    return (
         <div className="main-content" style={pageStyles}>
            <div className="about-hero-section">
                <Container className="text-center">
                    <h1 className="hero-title">Global Travel Wholesaler</h1>
                    <p className="hero-subtitle">One stop solution for your travel needs</p>
                </Container>
            </div>

            <div className="page-content">
                <Container>
                    {/* About Us Section */}
                    <section className="about-section">
                        <Row className="align-items-center">
                            <Col lg={6} className="mb-4 mb-lg-0">
                                <img src="/assets/images/teamwork.png" alt="Team collaborating" className="img-fluid rounded shadow-lg" />
                            </Col>
                            <Col lg={6}>
                                <h2 className="section-title">About {DefaultData?.DEFAULTBRANDNAME}</h2>
                                <p className="lead-text">
                                    {DefaultData?.DEFAULTBRANDNAME} is a Global Travel Wholesaler based in Dubai and one of the largest and most experienced wholesalers in the tourism industry. Established in 2019, we invaded the B2B space to provide solutions for the needs of the modern travel industry.
                                </p>
                                <p>
                                    Our success has been made possible through the concerted effort of our experienced, dynamic, and dedicated service team. We strongly emphasize customer care, attentive listening, and prompt response to enquiries.
                                </p>
                            </Col>
                        </Row>
                    </section>

                    {/* NEW: Message from the CEO Section */}
                    <section className="ceo-message-section">
                        <Row className="justify-content-center align-items-center">
                            <Col lg={8} className="text-center">
                                <h2 className="section-title">A Message to Our Partners</h2>
                                <blockquote className="ceo-quote">
                                    "Welcome to {DefaultData?.DEFAULTBRANDNAME}. We're passionate about travel and about providing the professional, personal service our agents deserve. As part of Advantage, we offer the best hot deals, competitive prices, and high-quality service support 24/7. Our experts are committed to exceeding your expectations!"
                                </blockquote>
                                <div className="ceo-signature">
                                    <p className="name">Sunil Reddy</p>
                                    <p className="title">CEO, {DefaultData?.WEBSITE}</p>
                                </div>
                            </Col>
                        </Row>
                    </section>

                    {/* Mission & Vision Section */}
                    <section className="mission-vision-section">
                        <Row>
                            <Col md={6} className="mb-4 mb-md-0">
                                <div className="info-box h-100">
                                    <i className="ri-flag-2-line info-icon"></i>
                                    <h3>Our Mission</h3>
                                    <p>"To build a simplified business-to-business solution for tourism services... to be the preferred provider for travel agencies to achieve their healthy growth and profitability."</p>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="info-box h-100">
                                    <i className="ri-eye-2-line info-icon"></i>
                                    <h3>Our Vision</h3>
                                    <p>"To be one of the leading travel wholesaler providers, benchmarking ourselves against international standards and best practices in terms of products, technology, and service level."</p>
                                </div>
                            </Col>
                        </Row>
                    </section>

                    {/* UPDATED: Core Values Section with descriptions */}
                    <section className="core-values-detailed-section">
                        <h2 className="section-title text-center">Our Values</h2>
                        <Row className="g-4">
                            {coreValues.map(value => (
                                <Col lg={4} md={6} key={value.name}>
                                    <div className="value-card-detailed">
                                        <div className="value-header">
                                            <i className={value.icon}></i>
                                            <h5>{value.name}</h5>
                                        </div>
                                        <p>{value.text}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </section>

                                      {/* Why Partner With Us Section */}
                    <section className="why-choose-us-section">
                        <h2 className="section-title text-center">Why Partner With Us?</h2>
                        <Row className="g-4">
                             {whyChooseUsPoints.map(point => (
                                <Col lg={6} key={point.title}>
                                    <div className="why-card">
                                        <div className="why-icon"><i className={point.icon}></i></div>
                                        <div className="why-text">
                                            <h5>{point.title}</h5>
                                            <p>{point.text}</p>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </section>

                    {/* Accreditation Section */}
                    <section className="accreditation-section text-center">
                        <h2 className="section-title">Our Accreditation & Membership</h2>
                        <Row className="g-4 justify-content-center align-items-center">
                            {accreditations.map(acc => (
                                <Col lg={2} md={3} xs={6} key={acc.name}>
                                    <div className="accreditation-logo-card">
                                        <img src={acc.logo} alt={`${acc.name} Logo`} title={acc.fullName} />
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </section>

                </Container>
            </div>
        </div>
    );
};

export default AboutCompany;